import {
  connect,
} from 'react-redux';
import {
  withTranslation,
} from 'react-i18next';

import {
  actions as mainActions,
} from '../../../redux/modules/main';

import RegionDialogView from './RegionDialogView';

// Types
import type {
  $State,
} from '../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './RegionDialogView';

const mapStateToProps = ({
  main,
}: $State): $StateProps => ({
  main,
});

const mapDispatchToProps = (dispatchAction): $DispatchProps => ({
  redirect: (params) => dispatchAction(
    mainActions.redirect(params),
  ),
  setActiveRegionId: (params) => dispatchAction(
    mainActions.setActiveRegionId(params),
  ),
  setActiveRegionSeasonId: (params) => dispatchAction(
    mainActions.setActiveRegionSeasonId(params),
  ),
  toggleRegionSelector: (params) => dispatchAction(
    mainActions.toggleRegionSelector(params),
  ),
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(RegionDialogView);

const TranslatedComponent = withTranslation()(ConnectedComponent);

const Component = TranslatedComponent;

export default Component;
